<template>
  <div :class="'epub_box ' + backclass">
    <div class="epub_box_c">
      <div class="read_left_box" v-if="pageType == 'pc'">
        <div class="read_left">
          <div class="title theme-title">商品详情</div>
          <div class="read_leftt1" v-if="coverFiles[0]">
            <el-image
              class="read_leftt1_img"
              :src="coverFiles[0].fullUrl"
              fit="contain"
            >
            </el-image>
            <p class="ellipsis-aRow">
              <span>{{
                callDictionaries(goodsTypeList, bookdetail.resourceType)
              }}</span>
              {{ bookdetail.goodsTitle }}
            </p>
          </div>
          <div class="read_leftt2">
            <li
              class="author-text-box"
              v-if="bookdetail.goodsType != 'looseleafOrtextbook'"
            >
              作者：<span class="author-text">{{
                bookdetail.author || "-"
              }}</span
              ><button
                v-if="isTrial && purchasePath && bookdetail.goodsTitle"
                @click="purchaseBut"
                class="purchase"
              >
                立即购买
              </button>
            </li>
            <li
              v-if="
                bookdetail.goodsType !== 'reference' &&
                bookdetail.goodsType !== 'other'
              "
            >
              ISBN: {{ bookdetail.isbn || "-" }}
            </li>
            <li v-if="bookdetail.goodsType != 'looseleafOrtextbook'">
              出版社：{{ bookdetail.publishingHouse || "-" }}
            </li>
            <li
              v-if="
                bookdetail.goodsType !== 'reference' &&
                bookdetail.goodsType !== 'other' &&
                bookdetail.goodsType != 'looseleafOrtextbook'
              "
            >
              出版时间：{{ bookdetail.publishDate || "-" }}
            </li>
            <li>教学属性：{{ bookdetail.teachPropertyAllStr || "-" }}</li>
            <li>提供机构：{{ bookdetail.instName || "-" }}</li>
          </div>
          <div class="read_leftt3">
            <p class="ellipsis-twoRow">
              {{ bookdetail.authorRecommendation }}
            </p>
          </div>
        </div>
        <div class="read_left2">
          <div class="title theme-title color_F6A200">资源文件</div>
          <div class="read_left2_ul">
            <li
              v-for="(item, index) in sourceList"
              :key="index"
              @click="getReadFileLink(index)"
              :class="index == readdefault ? 'active' : ''"
            >
              <p class="ellipsis-aRow">
                {{ item.sourceName }}.{{ item.fileType }}
              </p>
              <!-- <span v-if="item.sourceStatus === '1'" class="mf">免费</span>
              <span v-if="item.sourceStatus === '0'" class="ff">付费</span>
              <span v-if="item.sourceStatus === '2'" class="mf">试读</span> -->
            </li>
          </div>
        </div>
      </div>
      <div class="componentsview">
        <epubread
          :isTrial="isTrial"
          ref="epubread"
          v-if="readtype === 'epub'"
          @readSchedule="readSchedule"
          @updateReadStatic="updateReadStatic"
        ></epubread>
        <pdfread
          ref="pdfread"
          :isTrial="isTrial"
          v-if="readtype === 'pdf'"
        ></pdfread>
        <pweread ref="pweread" v-if="readtype === 'pwe'"></pweread>
        <audioread
          ref="audioread"
          :select_index="cover_fullUrl"
          v-if="readtype === 'audioread'"
        ></audioread>
        <imgread ref="imgread" v-if="readtype === 'img'"></imgread>
        <videoread ref="videoread" v-if="readtype === 'videoread'"></videoread>
        <zipread ref="zipread" v-if="readtype === 'zipread'"></zipread>
        <htmlread ref="htmlread" v-if="readtype === 'htmlread'"></htmlread>
        <leaflet ref="leafletread" v-if="readtype === 'leafletread'"></leaflet>
      </div>
    </div>
    <!-- v-if="robotId.indexOf($route.query.goodsId) !== -1" -->
    <!-- <robot @sending="sending" :msg="msg" /> -->
  </div>
</template>

<script>
import md5 from "js-md5";
import integralBox from "@/components/integralBox.vue";
import { mapGetters } from "vuex";
import {
  goodsInfoDetail,
  teachingAttrList,
  updateRecordAndSchedule,
  selectReadSchedule,
  IsBuyResource,
} from "@/api/bookstore/bookstore";
import { rsaDecrypt } from "@/utils/jsencrypt";
import {
  selectTimeParameter, //获取调用阅读时长接口频率
} from "@/api/special/special";
import { salt, publicKey } from "../../utils/config";
import { getFileLink } from "@/api/special/special";
import epubread from "./xmlComponents/epubread.vue";
import pdfread from "./xmlComponents/pdfread.vue";
import pweread from "./xmlComponents/pweread.vue";
import audioread from "./xmlComponents/audioread.vue";
import imgread from "./xmlComponents/imgread.vue";
import videoread from "./xmlComponents/videoread.vue";
import zipread from "./xmlComponents/zipread.vue";
import htmlread from "./xmlComponents/htmlread.vue";
import leaflet from "./xmlComponents/leaflet.vue";
import robot from "@/components/robot.vue";
export default {
  components: {
    epubread,
    pdfread,
    pweread,
    audioread,
    imgread,
    videoread,
    zipread,
    htmlread,
    leaflet,
    integralBox,
    robot,
  },
  computed: {
    ...mapGetters(["backclass"]),
  },
  data() {
    return {
      goodsFilePath: "", //mp3 mp4的数据
      bookdetail: {}, //基本信息
      sourceList: [], //文件信息
      readdefault: 0, //默认阅读第一个
      readtype: "", //阅读类型
      coverFiles: [], //封面
      goodsTypeList: [],
      ouchnoss1: null,
      first: true,
      goods_index: "", //选择的第几个
      goodsTypes: "", //资源的类型
      isTrial: true, //试读
      purchasePath: "",
      TimeParameter: 1,
      setInterval2: null,
      readingLocation: "epubcfi(/6/10!/4,/2[isbn9787304098780_1]/1:0,/8/2/1:1)",
      msg: {},
      robotId: "1669152756075728896", //可以使用小智答疑的商品id
      videoUrl: "",
      str: "",
      operationalState: 0,
      pageType: window.innerWidth > 1000 ? "pc" : "h5",
      userData: [],
    };
  },
  watch: {
    //监听路由变化

    $route() {},
  },
  destroyed() {
    clearInterval(this.setInterval2);
  },
  created() {
    // textBooksRead?goodsId=1739090188451319808&sysId=1643820911272529920&platform=out&token=jPodt1NEgryZCWAr4hAb+255fDmyCKnxubh/3+43WwQKtKNSmAkWBTnlFnoQtjG27mYhvctBSrTF9a7k4St1ZQ==$HXhBL71dbGUU46JcEoqUS4LewMm1ttho9yBeAJgyQoa8MzV4TfHJ4i4nSUpAXRCEjUtXX/hPgYDosG03eolG3Q==
    let router = this.$route.query;
    // console.log(decodeURIComponent(router.token));
    if (rsaDecrypt(router.token, publicKey)) {
      this.userData = rsaDecrypt(router.token, publicKey).split("_") || [];
    }
    let currentTime=new Date().getTime();
    if(((currentTime-parseInt(this.userData[1]))/1000/60)>10){
      this.$message.error("阅读链接已过期，请重新获取");
      return
    }
    this.purchasePath = router.purchasePath;
    this.str =
      "goodsId=" +
      router.goodsId +
      "&sysId=" +
      router.sysId +
      "&platform=" +
      router.platform;

    // // md5加盐
    let data = md5(salt + this.str);
    if (router.sign == data) {
      let Time = new Date().getTime();
      // 调用学习平台接口 判断是否购买
      IsBuyResource({
        studentNumber: this.userData[0],
        productId: router.goodsId,
        time: Time,
        sign: md5("TextbookOrder" + Time).toUpperCase(),
      }).then((res) => {
        if (res.data == "true") {
          this.isTrial = false;
        }
      });

      this.readdefault = this.$route.query.readdefault || 0;
      this.goodsInfoDetail(); //获取商品详情
      teachingAttrList("oc_resource_file").then((res) => {
        this.goodsTypeList = res.data;
      });
    } else {
      this.$message.error("阅读链接已过期，请重新获取");
    }
  },
  methods: {
    readSchedule(readingLocation, readSchedule) {
      let data = {
        goodsFileId: this.sourceList[this.readdefault].filesId,
        goodsId: this.$route.query.goodsId,
        platformCode: this.$route.query.sysId,
        readingLocation: readingLocation,
        stuNum: this.$route.query.stuNum || 0,
        readSchedule: readSchedule || 0,
      };
      updateRecordAndSchedule(data);
    },

    // 更新阅读状态
    updateReadStatic() {
      this.operationalState = 0;
    },
    goodsInfoDetail() {
      //第一步.获取商品详情
      goodsInfoDetail(this.$route.query.goodsId).then((res) => {
        this.bookdetail = res.data.goods || {};
        this.sourceList = res.data.sourceList;
        this.coverFiles = res.data.coverFiles;
        if (this.coverFiles.length > 0) {
          this.cover_fullUrl = this.coverFiles[0].fullUrl;
        }
        this.goodsTypes = res.data.goods.goodsType;
        document.title = res.data.goods.goodsTitle || "开放云书院";
        this.getReadFileLink(this.readdefault);
      });
    },
    getReadFileLink(index) {
      getFileLink({
        goodsId: this.$route.query.goodsId,
        filesId: this.sourceList[index].filesId,
        fileType: this.sourceList[index].fileType,
      }).then((result) => {
        let data = {
          goodsFileId: this.sourceList[this.readdefault].filesId,
          platformCode: this.$route.query.sysId,
          stuNum: this.$route.query.stuNum,
        };

        selectReadSchedule(data).then((res) => {
          if (res.data) {
            this.tabbook(
              this.sourceList[index],
              index,
              result.data.filePath,
              res.data.readingLocation
            );
          } else {
            this.tabbook(
              this.sourceList[index],
              index,
              result.data.filePath,
              ""
            );
          }
        });

        selectTimeParameter().then((res) => {
          //更新进度
          this.TimeParameter = res.data;
          this.setInterval2 = setInterval(() => {
            this.operationalState++;
            if (this.operationalState < 60) {
              if (this.readtype === "epub") {
                this.$refs.epubread.updateOcReadSchedule();
              } else if (this.readtype === "pdf") {
                this.readSchedule(
                  this.$refs.pdfread.PdfIndex,
                  Number(
                    this.$refs.pdfread.PdfIndex /
                      this.$refs.pdfread.PdfItems.length
                  )
                );
              } else {
                // this.readSchedule(0, 0);
              }
            }
          }, this.TimeParameter * 60000);
        });
      });
    },
    tabbook(item, index, filePath, readingLocation) {
      console.log(item);
      if (this.first) {
        //判断点击次数
        this.readdefault = index;
        this.first = false;
      } else {
        if (index === this.readdefault) {
          return;
        } else {
          this.readdefault = index;
        }
      }

      if (this.goodsTypes == "looseleafOrtextbook") {
        if (item.type == "looseLeaf" || item.type == "textBook") {
          this.readtype = "leafletread";

          // this.$router.replace({
          //   path: "/textBookReader",
          //   query: {
          //     pageType: "pc",
          //     businessType: "textBook",
          //     textBookId: item.filesId,
          //     bookName: item.bookName,
          //     isTrial: item.isTrial,
          //     isShowAi: item.isShowAi,
          //     catalogId: this.$route.query.catalogId,
          //   },
          // });
          // setTimeout(() => {
          //   this.$refs.leafletread.looseleaf(
          //     item,
          //     index,
          //     this.$route.query.catalogId || "",
          //     this.pageType
          //   );
          // }, 200);
          setTimeout(()=>{
            this.$refs.leafletread.src =
            `./#/booksRead-mobile?pageType=${this.pageType}&businessType=textBook&textBookId=` +
            item.filesId +
            "&bookName=" +
            item.bookName +
            "&isTrial=" +
            this.isTrial +
            "&isShowAi=" +
            item.isShowAi +
            "&catalogId=" +
            (this.$route.query.catalogId || "");
          },200)
            
          // location.replace(src);
          // }
        }
      } else if (item.fileName) {
        if (
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
          "PUB"
        ) {
          if (
            item.fileName.substring(item.fileName.length - 4).toUpperCase() ===
            "EPUB"
          ) {
            this.readtype = "epub";
            setTimeout(() => {
              this.$refs.epubread.tabbook(
                item,
                index,
                filePath,
                readingLocation
              );
            }, 200);
          } else {
            this.$alert("资源升级中，暂不支持阅读此文件", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                //   this.$router.go(-1);
              },
            });
          }
        } else if (
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
          "PDF"
        ) {
          this.readtype = "pdf";
          setTimeout(() => {
            this.$refs.pdfread.tabbook(item, index, filePath, readingLocation);
          }, 200);
        } else if (
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "PPT" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "PTX" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "OCX" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "DOC" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "XLS" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "LSX"
        ) {
          this.readtype = "pwe";
          setTimeout(() => {
            this.$refs.pweread.tabbook(item, index, filePath, readingLocation);
          }, 200);
        } else if (
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "MP4" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "WMV" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "AVI"
        ) {
          this.readtype = "videoread";
          setTimeout(() => {
            this.$refs.videoread.tabbook(
              item,
              index,
              filePath,
              readingLocation
            );
          }, 200);
        } else if (
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
          "MP3"
        ) {
          this.readtype = "audioread";
          setTimeout(() => {
            this.$refs.audioread.tabbook(
              item,
              index,
              filePath,
              readingLocation
            );
          }, 200);
        } else if (
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "JPG" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "PNG" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "GIF" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "BPM" ||
          item.fileName.substring(item.fileName.length - 4).toUpperCase() ===
            "JPEG"
        ) {
          this.readtype = "img";
          setTimeout(() => {
            this.$refs.imgread.tabbook(item, index, filePath, readingLocation);
          }, 200);
        } else if (
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "ZIP" ||
          item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
            "RAR"
        ) {
          if (
            this.bookdetail.resourceType === "html" &&
            item.fileName.substring(item.fileName.length - 3).toUpperCase() ===
              "ZIP"
          ) {
            this.readtype = "htmlread";
            setTimeout(() => {
              this.$refs.htmlread.tabbook(item, index, this);
            }, 200);
          } else {
            this.readtype = "zipread";
            setTimeout(() => {
              this.$refs.zipread.tabbook(item, index, this);
            }, 200);
          }
        } else if (this.goodsTypes == "looseleafOrtextbook") {
          if (item.type == "looseLeaf" || item.type == "textBook") {
            this.readtype = "leafletread";
            if (this.isTrial) {
              this.$refs.leafletread.looseleaf(item, index);
            } else {
              setTimeout(() => {
                this.$refs.leafletread.tabbook(item, index);
              }, 200);
            }
          }
        }
      }
    },
    purchaseBut() {
      if (this.purchasePath) {
        window.open(this.purchasePath);
      }
    },

    sending(question) {
      // 砖基础应满足允许刚性角的要求。是对还是错?
      this.$axios
        .post(process.env.VUE_APP_roboturl, {
          query: question,
          book: "建筑构造",
          stream: "True",
        })
        .then((res) => {
          let content = "";
          let eaderStream = res.data.split("\r\n\r\n");
          console.log(eaderStream);
          eaderStream.map((item) => {
            if (item) {
              let textData = item.split("data:");
              textData.map((items) => {
                if (items && items.indexOf("{") !== -1) {
                  let text = JSON.parse(items);
                  if (text.content) {
                    content += text.content;
                  }
                } else if (items.indexOf("http") !== -1) {
                  this.videoUrl = items.slice(1, items.length - 7);
                }
              });
            }
          });
          this.msg = {
            content: content,
            type: "text",
            videoUrl: this.videoUrl,
          };
        });
    },
  },
};
</script>
<style scoped lang="scss">
#extras {
  /*  width: 600px;
margin: 40px auto;*/
  width: 600px;
  height: 100vh;
  /* overflow: auto; */
  margin: 0 auto;
}

.read_center_box > iframe {
  background: white;
  box-shadow: 0 0 4px #ccc;
  /*margin: 10px;
padding: 20px;*/
}

#viewer {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-bottom: 20px;
  box-shadow: 0 0 5px #848484;
  overflow: hidden;
  /*  !* overflow: auto; *!
margin: 0 auto;*/
}

#highlights {
  list-style: none;
  margin-left: 0;
  padding: 0;
}

#highlights li {
  list-style: none;
  margin-bottom: 20px;
  border-top: 1px solid #e2e2e2;
  padding: 10px;
}

#highlights a {
  display: block;
}

#viewer.spreads {
  top: 0;
  margin-top: 50px;
}

[ref="epubjs-mk"] {
  background: url("data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPScxLjEnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZycgeG1sbnM6eGxpbms9J2h0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsnIHg9JzBweCcgeT0nMHB4JyB2aWV3Qm94PScwIDAgNzUgNzUnPjxnIGZpbGw9JyNCREJEQkQnIGlkPSdidWJibGUnPjxwYXRoIGNsYXNzPSdzdDAnIGQ9J00zNy41LDkuNEMxOS42LDkuNCw1LDIwLjUsNSwzNC4zYzAsNS45LDIuNywxMS4zLDcuMSwxNS42TDkuNiw2NS42bDE5LTcuM2MyLjgsMC42LDUuOCwwLjksOC45LDAuOSBDNTUuNSw1OS4yLDcwLDQ4LjEsNzAsMzQuM0M3MCwyMC41LDU1LjQsOS40LDM3LjUsOS40eicvPjwvZz48L3N2Zz4=")
    no-repeat;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 0;
}

.epub_box {
  width: 100%;
  overflow: hidden;
  background: rgb(242, 242, 242);
  // padding: 0 20px;
  box-sizing: border-box;
  min-height: 100vh;
}

.epub_box_c {
  width: 100%;
  display: table;
}

.read_left_box {
  width: 304px;
  float: left;
  margin-right: 15px;
}

.read_left {
  width: 100%;
  float: left;
  margin-bottom: 16px;
  padding: 15px;
  box-sizing: border-box;
}

.epub_box .bread {
  width: 100% !important;
}

.read_leftt1 {
  margin-top: 12px;
  margin-bottom: 12px;
}

.read_leftt1_img {
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto;
  box-shadow: 0 0 3px #ccc;
  margin-bottom: 14px;
}

.read_leftt1 > p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
}

.read_leftt1 > p span {
  border: 1px solid #0081ce;
  border-radius: 6px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #0081ce;
  line-height: 22px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 10px;
}

.read_leftt2 {
  width: 100%;
  overflow: hidden;
  padding: 0 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 10px;
}

.read_leftt2 li {
  list-style: none;
  width: 100%;
  float: left;
  font-size: 14px;
  margin-bottom: 8px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.read_leftt3 {
  width: 100%;
  float: left;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.read_left2 {
  width: 100%;
  float: left;
  margin-bottom: 16px;
  padding: 15px;
  box-sizing: border-box;
}

.read_left2 .theme-title::before {
  background: #f6a200;
}

.read_left2_ul {
  width: 100%;
  max-height: calc(95vh - 610px);
  overflow-y: scroll;
  float: left;
  margin-top: 15px;
  padding: 0 5px 0 0;
}

.read_left2_ul li {
  width: 100%;
  float: left;
  height: 46px;
  border-top: 1px solid #f2f2f2;
  list-style: none;
}

.read_left2_ul li p {
  font-size: 14px;
  float: left;
  width: calc(100% - 30px);
  cursor: pointer;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
  color: #333333;
}

.read_left2_ul li span {
  float: right;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
}

.read_left2_ul li span.mf {
  color: #2e9adb;
}

.read_left2_ul li span.ff {
  color: #ff5353;
}

.read_left2_ul li.active p {
  color: #2e9adb;
}

.read_center_box {
  float: left;
  width: calc(100vw - 455px);
  min-height: 95vh;
  position: relative;
}

.read_right_box {
  float: right;
  width: 60px;
}

.read_right_box1 {
  width: 100%;
  float: left;
  position: relative;
}

.read_right_box1 li {
  list-style: none;
  width: 100%;
  height: 60px;
  float: left;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
}

.read_right_box1 li img {
  display: block;
  margin: 10px auto;
  height: 20px;
}

.read_right_box1 li p {
  font-size: 13px;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

.read_right_box2 {
  width: 100%;
  float: left;
  margin-top: 8px;
}

.read_right_box2 img {
  display: block;
  margin: 12px auto;
  cursor: pointer;
}

.mulu {
  width: 100%;
  max-height: calc(100vh - 130px);
  float: left;
  /* padding: 15px 24px; */
  box-sizing: border-box;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
}

.mulu::-webkit-scrollbar {
  width: 5px;
  /*height: 4px;*/
}

.mulu::-webkit-scrollbar-thumb {
  border-radius: 15px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #fbfbfb;
}

.mulu::-webkit-scrollbar-track {
  border-radius: 0;
}

.mulu > i {
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
}

.mulu > li {
  list-style: none;
  width: 100%;
  float: left;
}

.rmulu li {
  cursor: pointer;
}

.mulu > li > p {
  width: 100%;
  float: left;
  font-size: 13px;
  font-family: PingFang SC;
  border-bottom: 1px dashed #ccc;
  margin-bottom: 5px;
  padding-bottom: 5px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}

.twomulu {
  margin-left: 10px;
}

.twomulu > li {
  width: 100%;
  list-style: outside;
  float: left;
  font-size: 13px;
  font-family: PingFang SC;
  border-bottom: 1px dashed #ccc;
  margin-bottom: 5px;
  padding-bottom: 5px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}

.mulu_liright {
  float: right;
}

.mulu_liright span {
  margin-left: 8px;
  cursor: pointer;
}

.shezhi {
  width: 100%;
  float: left;
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
}

.shezhi > i {
  position: absolute;
  right: 0px;
  top: -10px;
  cursor: pointer;
}

.shezhi li {
  width: 100%;
  float: left;
  list-style: none;
  margin-bottom: 30px;
}

.shezhi li p {
  float: left;
  font-size: 13px;
  height: 21px;
  line-height: 21px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
}

.xz_box {
  width: calc(100% - 80px);
  margin-left: 15px;
  float: left;
  height: 21px;
}

.shezhi li:last-child {
  margin-bottom: 0;
}

.ydzt span {
  width: 22px;
  height: 22px;
  float: left;
  border: 1px solid #999999;
  border-radius: 50%;
  margin-right: 10px;
  cursor: pointer;
}

.ydzt span.active {
  border: 1px solid red;
}

.ydzt span.active:before {
  content: "√";
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 22px;
  color: red;
  display: block;
}

.zwzt span {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 21px;
  margin-right: 10px;
  cursor: pointer;
}

.zwzt span.active {
  color: #0081ce;
}

.ztdx .el-input-number {
  margin-top: -4px;
}

.shezhi_button {
  display: table;
  margin: 20px auto 0;
}

.shezhi_button span {
  width: 80px;
  cursor: pointer;
  float: left;
  border: 1px solid #2e9adb;
  text-align: center;
  line-height: 24px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #2e9adb;
  height: 24px;
  background: #fff;
  border-radius: 6px;
  margin-right: 30px;
}

.shezhi_button span:last-child {
  margin-right: 0;
}

.shezhi_button span:first-child {
  background: #2e9adb;
  color: #fff;
}

.color_hei .read_left {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_left2 {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_right_box1 {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_center_box {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_leftt1 > p {
  color: #ccc;
}

.color_hei .read_leftt2 li {
  color: #ccc;
}

.color_hei .read_leftt3 {
  color: #ccc;
}

.color_hei .theme-title {
  color: #ccc;
}

.color_hei .read_left2_ul li p {
  color: #ccc;
}

.color_hei .read_right_box1 li p {
  color: #ccc;
}

.dqyd {
  line-height: 35px;
  margin-left: 20px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}

.dqyd img {
  float: left;
  width: 12px;
  margin-top: 12px;
  margin-right: 5px;
}

/* 默认 */
.zt_moren {
  background: #e6e1d5;
  position: relative;
}

.zt_moren .read_left {
  background: #f5f1e8;
}

.zt_moren .read_left2 {
  background: #f5f1e8;
}

.zt_moren .read_right_box1 {
  background: #f5f1e8;
}

.zt_moren .read_center_box {
  background: #f5f1e8;
}

.zt_moren .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_moren .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_moren .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 牛皮纸 */
.zt_niupizhi {
  background: #dbcfa5;
}

.zt_niupizhi .read_left {
  background: #efe7c9;
}

.zt_niupizhi .read_left2 {
  background: #efe7c9;
}

.zt_niupizhi .read_right_box1 {
  background: #efe7c9;
}

.zt_niupizhi .read_center_box {
  background: #efe7c9;
}

.zt_niupizhi .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_niupizhi .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_niupizhi .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 淡绿色 */
.zt_danlvse {
  background: #d2e0d0;
}

.zt_danlvse .read_left {
  background: #e6f0e6;
}

.zt_danlvse .read_left2 {
  background: #e6f0e6;
}

.zt_danlvse .read_right_box1 {
  background: #e6f0e6;
}

.zt_danlvse .read_center_box {
  background: #e6f0e6;
}

.zt_danlvse .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_danlvse .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_danlvse .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 淡蓝色 */
.zt_danlanse {
  background: #d2dcdc;
}

.zt_danlanse .read_left {
  background: #e6f0f0;
}

.zt_danlanse .read_left2 {
  background: #e6f0f0;
}

.zt_danlanse .read_right_box1 {
  background: #e6f0f0;
}

.zt_danlanse .read_center_box {
  background: #e6f0f0;
}

.zt_danlanse .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_danlanse .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_danlanse .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 淡粉色 */
.zt_danfense {
  background: #e6cfcf;
}

.zt_danfense .read_left {
  background: #f0e5e5;
}

.zt_danfense .read_left2 {
  background: #f0e5e5;
}

.zt_danfense .read_right_box1 {
  background: #f0e5e5;
}

.zt_danfense .read_center_box {
  background: #f0e5e5;
}

.zt_danfense .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_danfense .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_danfense .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 灰色 */
.zt_huise {
  background: #d4d4d4;
}

.zt_huise .read_left {
  background: #dadada;
}

.zt_huise .read_left2 {
  background: #dadada;
}

.zt_huise .read_right_box1 {
  background: #dadada;
}

.zt_huise .read_center_box {
  background: #dadada;
}

.zt_huise .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_huise .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_huise .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 黑色 */
.zt_heise {
  background: #000;
}

.zt_heise .read_left {
  background: #424242;
}

.zt_heise .read_left2 {
  background: #424242;
}

.zt_heise .read_right_box1 {
  background: #424242;
}

.zt_heise .read_center_box {
  background: #424242;
}

.zt_heise .read_leftt2 {
  border-color: #fff;
}

.zt_heise .read_right_box1 li {
  border-color: #fff;
}

.zt_heise .read_left2_ul li {
  border-color: #fff;
}

.zt_heise .theme-title {
  color: #fff;
}

.zt_heise .read_leftt1 > p {
  color: #fff;
}

.zt_heise .read_leftt2 li {
  color: #fff;
}

.zt_heise .read_leftt3 {
  color: #fff;
}

.zt_heise .read_left2_ul li p {
  color: #fff;
}

.zt_heise .read_right_box1 li p {
  color: #fff;
}

#divider {
  position: absolute;
  width: 1px;
  border-right: 1px #000 solid;
  height: 90%;
  z-index: 1;
  left: 50%;
  margin-left: -1px;
  top: 6%;
  opacity: 0.15;
  box-shadow: -2px 0 15px rgba(0, 0, 0, 1);
}

.slider_box {
  position: absolute;
  width: 98%;
  bottom: -6px;
  opacity: 0.4;
}

.slider_box:hover {
  opacity: 1;
}

::v-deep .bread {
  width: 100% !important;
}

::v-deep .epub-container::-webkit-scrollbar {
  width: 5px;
  display: none !important;
  /*height: 4px;*/
}

::v-deep .epub-container::-webkit-scrollbar-thumb {
  border-radius: 15px;
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3); */
  /* background: #fbfbfb; */
  background: rgba(144, 147, 153, 0.3);
}

::v-deep .epub-container::-webkit-scrollbar-thumb:hover {
  background: rgba(144, 147, 153, 0.5);
}

::v-deep .epub-container::-webkit-scrollbar-track {
  border-radius: 0;
}
.author-text-box {
  display: flex;
  align-items: center;
}
.author-text {
  display: block;
  width: 126px;
  padding-right: 10px;
}

.purchase {
  width: 70px;
  height: 26px;
  font-size: 14px;
  padding: 1px 2px;
  cursor: pointer;
  background-color: #f1f9ec;
  color: #73c249;
  border: 1px solid #73c249;
  border-radius: 6px;
}
</style>
